export const SopClass = {
  VLWholeSlideMicroscopyImage: '1.2.840.10008.5.1.4.1.1.77.1.6',
  VLMicroscopicImage: '1.2.840.10008.5.1.4.1.1.77.1.2',
  /** A document (a PDF, series kind 'document'): opened by the document view, never by an engine. */
  EncapsulatedPDF: '1.2.840.10008.5.1.4.1.1.104.1',
} as const;

/** Single-frame visible-light images — photomicrographs, gross and specimen
 *  photos — shown in the slide viewport as a one-tile pyramid. Radiology
 *  classes (CT, MR, …) are left out on purpose: they need windowing, not this. */
export const SINGLE_FRAME_IMAGE_SOP_CLASSES: string[] = [
  '1.2.840.10008.5.1.4.1.1.77.1.1', // VL Endoscopic Image
  SopClass.VLMicroscopicImage,
  '1.2.840.10008.5.1.4.1.1.77.1.3', // VL Slide-Coordinates Microscopic Image
  '1.2.840.10008.5.1.4.1.1.77.1.4', // VL Photographic Image (XC)
  '1.2.840.10008.5.1.4.1.1.7', // Secondary Capture Image
];

export const WSI_SOP_CLASSES: string[] = [
  SopClass.VLWholeSlideMicroscopyImage,
  SopClass.VLMicroscopicImage,
];
